import { Box } from "@chakra-ui/react";
import React, { Component } from "react";
import Title from "../../ComponentsPedidos/Title.js";
import {
  SelectBillingTypeContainer,
  SelectBillingTypeContainerContent,
  SelectBillingTypeContainerContentBox,
} from "./styles.js";

class SelectBillingType extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Box>
        <SelectBillingTypeContainer>
          <Title>
            <p>
              Para quantos clientes você vai <strong>faturar e entregar</strong>{" "}
              nesse pedido?
            </p>
          </Title>

          <SelectBillingTypeContainerContent>
            <SelectBillingTypeContainerContentBox
              onClick={() => this.props.billingTypeOne()}
            >
              <p>
                APENAS
                <br />
                UM CLIENTE
              </p>
            </SelectBillingTypeContainerContentBox>
            <SelectBillingTypeContainerContentBox
              onClick={() => this.props.billingTypeMoreThanOne()}
            >
              <p>
                DOIS OU MAIS
                <br />
                CLIENTES
              </p>
            </SelectBillingTypeContainerContentBox>
          </SelectBillingTypeContainerContent>
        </SelectBillingTypeContainer>
      </Box>
    );
  }
}

export default SelectBillingType;
